const _none = "none"
const _inline = "var(--aspect-ratio-inline, none)"
const config = { "none": _none, "inline": _inline, "1/1": "1 / 1", "3/1": "3 / 1", "3/2": "3 / 2", "16/9": "16 / 9", "16/7": "16 / 7", "4/5": "4 / 5",  }
export { config as default, _none, _inline }